import { MuiClassCollection } from "../../foundations/mui-class-collection.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
const checkboxStylesOverride = {
  root: {
    padding: Spacing["500"],
    [`&.${MuiClassCollection.disabled}`]: {
      pointerEvents: "initial",
      cursor: "not-allowed",
      "&:hover": {
        backgroundColor: "initial"
      }
    }
  }
};
export {
  checkboxStylesOverride
};
//# sourceMappingURL=styles.es.js.map
